import React from 'react'
import PropTypes from 'prop-types'
import { startCase } from 'lodash'

import Styles from './index.scss'

const SearchBox = props => (
  <div className="pull-left">
    <form
      name="filter-form"
      onSubmit={props.submitFilters}
      style={{ display: 'inline-table' }}
    >
      <div className={`${Styles['search-box']} form-group`}>
        <strong>FILTER BY:</strong>
      </div>
      <div className={`${Styles['search-box']} form-group`}>
        <div className="input-group input-group-md">
          <select
            className={`${Styles['search-category']} form-control`}
            onChange={props.handleSelectedCountry()}
            name="country"
            value={props.countryState}
          >
            <option>Country</option>
            {props.selectionsCountry.map((country, index) => (
              <option key={`country_${index + 1}`} value={country.value}>
                {startCase(country.label)}
              </option>
              ))}
          </select>
        </div>
      </div>
      <div className={`${Styles['search-box']} form-group`}>
        <div className="input-group input-group-md">
          <select
            className={`${Styles['search-category']} form-control`}
            onChange={props.handleSelectedService()}
            name="service"
            value={props.serviceState}
          >
            <option>Service Format</option>
            {props.selectionsService.map((service, index) => (
              <option key={`country_${index + 1}`} value={service.value}>
                {startCase(service.label)}
              </option>
              ))}
          </select>
        </div>
      </div>
      <div className={`${Styles['search-box']} form-group`}>
        <button type="submit" className="btn btn-sm btn-info uppercase">
          Apply Filter
        </button>
      </div>
      <div className={`${Styles['search-box']} form-group`}>
        <button
          type="button"
          className="btn btn-default btn-sm uppercase"
          onClick={props.cleanFilters()}
        >
          Reset
        </button>
      </div>
    </form>
  </div>
  )

SearchBox.defaultProps = {
  searchProfileField: '',
}

SearchBox.propTypes = {
  selectionsCountry: PropTypes.arrayOf(PropTypes.object).isRequired,
  selectionsService: PropTypes.arrayOf(PropTypes.object).isRequired,
  submitFilters: PropTypes.func.isRequired,
  handleSelectedCountry: PropTypes.func.isRequired,
  handleSelectedService: PropTypes.func.isRequired,
  countryState: PropTypes.string.isRequired,
  serviceState: PropTypes.string.isRequired,
  cleanFilters: PropTypes.func.isRequired,
}

export default SearchBox
